let virtualId = 0;
/**
 * Get a negative id and decrement it each time it is consumed to make sure we don't have 2 times the same negative value.
 *
 * This is used to handle the optimistic create where the entities doesn't have any id until the BE response
 */
export default () => --virtualId;
